import Image from 'next/image'

import { cn } from '@/_lib/utils'

const ORDER_DOCTOR_ICONS = {
	ageRange: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/legacy/ikona-sluzby-3.svg`,
	languages: `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/health-education.svg`
} as const

function OrderDoctorInfoItem({ icon, label }: { icon: string; label: string }) {
	return (
		<div className='flex items-start gap-2'>
			<Image
				src={icon}
				alt=''
				width={24}
				height={24}
				aria-hidden
				unoptimized={true}
				className='w-4 h-4 md:w-5 md:h-5 mt-0 md:mt-[2px]'
			/>
			<p className='text-xs font-light text-medante-purple-dark/90 md:text-sm md:font-normal'>
				{label}
			</p>
		</div>
	)
}

export function AOrderDoctorBlock({
	photoUrl,
	fullName,
	position,
	ageLabel,
	languagesLabel,
	className
}: {
	photoUrl?: string | null
	fullName: string
	position?: string | null
	ageLabel: string
	languagesLabel?: string | null
	className?: string
}) {
	return (
		<div className={cn('flex lg:flex-col gap-2', className)}>
			<div className='flex items-start gap-2 md:gap-3'>
				<div className='h-8 md:h-12 w-8 md:w-12 shrink-0'>
					{photoUrl ? (
						<Image
							src={photoUrl}
							alt={fullName}
							width={40}
							height={40}
							unoptimized={true}
							className='h-8 md:h-10 w-8 md:w-10 rounded-full object-cover'
						/>
					) : (
						<div className='h-8 md:h-12 w-8 md:w-12 rounded-full bg-medante-purple object-cover' />
					)}
				</div>
				<div className='min-w-0 flex-1 pt-0.5 -mt-px'>
					<p className='text-medante-purple-dark font-medium'>{fullName}</p>
					{position ? (
						<p className='text-xs text-medante-purple-dark/80 md:text-sm font-normal'>
							{position}
						</p>
					) : null}
				</div>
			</div>

			<div className='flex flex-col gap-1'>
				<OrderDoctorInfoItem icon={ORDER_DOCTOR_ICONS.ageRange} label={ageLabel} />
				{languagesLabel ? (
					<OrderDoctorInfoItem
						icon={ORDER_DOCTOR_ICONS.languages}
						label={languagesLabel}
					/>
				) : null}
			</div>
		</div>
	)
}
